import { useState } from 'react';
import { useDyteMeeting } from '@dytesdk/react-web-core';
import {
	DyteMicToggle,
	DyteCameraToggle,
	DyteButton,
	DyteDialogManager,
	DyteLeaveButton,
	DyteSettingsToggle,
	DyteChatToggle,
	DyteSidebar,
	DyteScreenShareToggle,
} from '@dytesdk/react-ui-kit';
import { useMediaQuery } from '@mui/material';

type Props = {
	isHost: boolean;
	showEndSessionModal: boolean;
	setShowEndSessionModal: (showEndSessionModal: boolean) => void;
};

const SessionFooter = ({ isHost, setShowEndSessionModal }: Props) => {
	const dyteMeeting = useDyteMeeting();

	const isMobile = useMediaQuery('(max-width: 960px)');

	const [states, setStates] = useState<Record<string, boolean>>({});

	const setState = (s: any) => setStates(states => ({ ...states, ...s }));

	return (
		<div className="container min-h-[70px] mx-auto flex items-center justify-center gap-2 dark:text-white flex-wrap">
			<DyteMicToggle data-testid="dyte-mic-toggle" size={isMobile ? 'sm' : 'md'} meeting={dyteMeeting.meeting} />
			<DyteCameraToggle data-testid="dyte-camera-toggle" size={isMobile ? 'sm' : 'md'} meeting={dyteMeeting.meeting} />
			<DyteScreenShareToggle
				data-testid="dyte-screenshare-toggle"
				size={isMobile ? 'sm' : 'md'}
				meeting={dyteMeeting.meeting}
			/>
			<DyteChatToggle
				data-testid="dyte-chat-toggle"
				size={isMobile ? 'sm' : 'md'}
				meeting={dyteMeeting.meeting}
				onClick={() => setState({ activeSidebar: !states.activeSidebar })}
			/>
			<DyteButton
				className="bg-inherit text-red-500"
				size={isMobile ? 'sm' : 'md'}
				onClick={() => setState({ activeSettings: true })}
			>
				<DyteSettingsToggle data-testid="dyte-settings-toggle" size={isMobile ? 'sm' : 'md'} />
			</DyteButton>

			<DyteButton
				className="bg-inherit text-red-500"
				size={isMobile ? 'sm' : 'md'}
				onClick={() => {
					// setShowEndSessionModal(true);
					// !isHost && setState({ activeLeaveConfirmation: true });
					setState({ activeLeaveConfirmation: true });
				}}
			>
				<DyteLeaveButton data-testid="dyte-leave-button" className="text-red-500" size={isMobile ? 'sm' : 'md'} />
			</DyteButton>

			{states.activeSidebar && (
				<div className="absolute bottom-[80px] right-1/3">
					<DyteSidebar
						size={isMobile ? 'sm' : 'md'}
						states={states}
						onDyteStateUpdate={e => setState(e.detail)}
						defaultSection="chat"
						// enabledSections={['chat']}
						meeting={dyteMeeting.meeting}
						className="h-[480px] w-[320px]"
					/>
				</div>
			)}

			<DyteDialogManager
				size={isMobile ? 'sm' : 'md'}
				data-testId="dyte-dialog-manager"
				meeting={dyteMeeting.meeting}
				states={states}
				onDyteStateUpdate={e => setState(e.detail)}
			/>
		</div>
	);
};

export default SessionFooter;
